export const firebaseConfig = {
  apiKey: 'AIzaSyARYDIr929kcHO5xnK8iUUouQT2-0POZac',
  authDomain: 'k-log-helth-vue.firebaseapp.com',
  databaseURL: 'https://k-log-helth-vue.firebaseio.com',
  projectId: 'k-log-helth-vue',
  storageBucket: 'k-log-helth-vue.appspot.com',
  messagingSenderId: '983533041816',
  appId: '1:983533041816:web:c6aeb04093447304e578ed',
  measurementId: 'G-Y9TKMFBKFR'
}
